import React from 'react';
import SubIndustryCard from '../Common/SubIndustry';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { IndustryEnum } from '../../config/Profiler_enum';

const SubIndustryBCM = (props) => {
  return (
    <SubIndustryCard
      industryType={IndustryEnum.BCM}
      questionId={ProfilerQuestionID.BUSINESS_BCM_SUBINDUSTRY}
      {...props}
    />
  );
};

export default SubIndustryBCM;
